// BuildOverview/BuildOverviewCache.js
// Map<rk, BuildStatus>. rk is the job name.
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'BuildOverviewCache';

class BuildOverviewCache extends CoreBase {
    _name = _name;

    _items = new Map();

    /**
     * REST fetch delivers the full job list — replaces the map.
     * @param {object[]} items
     */
    setAll = (items) => {
        this._items = new Map(items.map((i) => [i.rk, i]));
    };

    /**
     * SignalR push can be 1 job or all — overwrites per rk.
     * @param {object[]} items
     */
    addOrUpdate = (items) => {
        items.forEach((i) => this._items.set(i.rk, i));
    };

    getAll = () => [...this._items.values()];

    /**
     * @param {string} rk
     * @returns {object|undefined}
     */
    get = (rk) => this._items.get(rk);

    clear = () => {
        this._items.clear();
    };
}

const buildOverviewCache = new BuildOverviewCache();
export default buildOverviewCache;
